import moment from "moment";
import { IDateRange } from "types/cart/shipment-review";

export interface QuantityUnavailableState {
    hasQuantityInUnavailable: boolean;
    hasQuantityInValidState: boolean;
    itemsThatShouldBeRemoved: string[];
}

export const isProductItemModalInError = (
    availableDays: { from: moment.Moment; until: moment.Moment | null },
    currentDate: moment.Moment,
    quantityUnavailableState: QuantityUnavailableState,
    uniqueDates: IDateRange[],
) => {
    const { hasQuantityInUnavailable } = quantityUnavailableState;
    if (hasQuantityInUnavailable) {
        return true;
    }

    const availableEnd = availableDays.until;

    const isAfterAvailableEnd = currentDate.isAfter(availableEnd);
    let hasAnyShipEndDateInThePast = false;
    for (const date of uniqueDates) {
        const momentDate = moment(date.shipEnd);
        if (currentDate.isAfter(momentDate)) {
            hasAnyShipEndDateInThePast = true;
            break;
        }
    }

    return isAfterAvailableEnd || hasAnyShipEndDateInThePast;
};
